/* eslint-disable no-magic-numbers */

import { TFunction } from 'i18next';

export enum TimeDurations {
  Min5 = 5 * 60 * 1000,
  Min4 = 4 * 60 * 1000,
  Min3 = 3 * 60 * 1000,
  Min2 = 2 * 60 * 1000,
  Min1 = 1 * 60 * 1000,

  Sec50 = 50 * 1000,
  Sec40 = 40 * 1000,
  Sec30 = 30 * 1000,
  Sec20 = 20 * 1000,
  Sec10 = 10 * 1000,
}

const TIME_THRESHOLDS: Array<[number, 'minutes' | 'minute' | 'seconds']> = [
  [TimeDurations.Min5, 'minutes'],
  [TimeDurations.Min4, 'minutes'],
  [TimeDurations.Min3, 'minutes'],
  [TimeDurations.Min2, 'minutes'],
  [TimeDurations.Min1, 'minute'],
  [TimeDurations.Sec50, 'seconds'],
  [TimeDurations.Sec40, 'seconds'],
  [TimeDurations.Sec30, 'seconds'],
  [TimeDurations.Sec20, 'seconds'],
  [TimeDurations.Sec10, 'seconds'],
];

export function getProgressMessage(
  remainingMs: number,
  t: TFunction<string, undefined>,
): string {
  for (const [threshold, unit] of TIME_THRESHOLDS) {
    if (remainingMs >= threshold) {
      const timeValue =
        unit === 'minutes' || unit === 'minute'
          ? threshold / 60000
          : threshold / 1000;
      return `${timeValue} ${t(`QR_CODE_LABEL_${unit.toUpperCase()}`)}`;
    }
  }

  return '';
}
